import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

import { ChartContainer, ChartTooltip, ChartTooltipContent } from '../ui/chart';
import { RadialBar, RadialBarChart, ResponsiveContainer } from 'recharts';

type LastMileVehicleTypes = 'bike' | 'e-bike' | 'e-van';

export const SimplifiedStatsCard = ({ stats, title }: { stats: Record<string, number>; title: string }) => {
  const getColor = (vehicleType: LastMileVehicleTypes) => {
    switch (vehicleType) {
      case 'bike':
        return 'green';
      case 'e-bike':
        return 'blue';
      case 'e-van':
        return 'orange';
      default:
        return 'blue';
    }
  };

  // Create a single data object with all stats
  const chartData = [stats];

  // Custom legend configuration
  const customLegendItems = Object.keys(stats || {})?.map((key, index) => ({
    value: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '),
    color: `hsl(var(--chart-${index + 1}))`,
  }));

  // Custom Legend component
  const CustomLegend = () => (
    <div className="flex justify-center items-center gap-4 w-full">
      {customLegendItems.map((item, index) => (
        <div key={index} className="flex items-center gap-1">
          <div className="w-3 h-3" style={{ backgroundColor: item.color }} />
          <span className="text-sm">{item.value}</span>
        </div>
      ))}
    </div>
  );

  return (
    <Card className="h-full">
      <div className="flex flex-col h-full">
        <CardHeader className="pb-2">
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent className="flex-1 flex flex-col">
          <div className="flex-1 flex flex-col justify-center">
            <div className="h-36 w-full">
              <ChartContainer
                config={{
                  ...Object.fromEntries(
                    Object.keys(stats || {}).map((k) => [
                      k,
                      {
                        label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '),
                        color: `hsl(var(--chart-${
                          getColor(k as LastMileVehicleTypes) === 'green'
                            ? '1'
                            : getColor(k as LastMileVehicleTypes) === 'blue'
                              ? '2'
                              : '3'
                        }))`,
                      },
                    ]),
                  ),
                }}
                className="h-full w-full"
              >
                <ResponsiveContainer width="100%" height="100%">
                  <RadialBarChart data={chartData} endAngle={180} innerRadius={60} outerRadius={110} cx="50%" cy="85%">
                    <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
                    {Object.keys(stats || {}).map((key, index) => (
                      <RadialBar
                        key={key}
                        dataKey={key}
                        name={key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')}
                        stackId="a"
                        cornerRadius={5}
                        fill={`hsl(var(--chart-${index + 1}))`}
                        className="stroke-transparent stroke-2"
                      />
                    ))}
                  </RadialBarChart>
                </ResponsiveContainer>
              </ChartContainer>
            </div>
            <CustomLegend />
          </div>
        </CardContent>
      </div>
    </Card>
  );
};
